/** @namespace chatStream */
import React from 'react';
import {useSelector} from "react-redux";
import {AgentContext} from './context';

/**
 * @function useChatStreamListener
 * @memberof chatStream
 * @param {string} [agentId]
 * @param {string} [collectionPath]
 * @param {string} [chatPath]
 * @returns {[chat:models.Chat.Data, collectionPath:string]}
 */
function useChatStreamListener(agentId, collectionPath, chatPath) {
  const agentContext = React.useContext(AgentContext);
  /** @type {[models.Chat.Data, string]} */
  const stream = useSelector((state) => {
    // return state.AI[agentContext.agent.agentId || agentId]?.[agentContext.agent.collectionPath || collectionPath];
    return state.AI[agentId || agentContext.agentId]?.chat; //?.[agentContext.agent.collectionPath || collectionPath];
  });

  if (stream && chatPath) {
    return (stream[1] === chatPath) ?
      [stream?.[0], stream?.[1], stream?.[2]] :
      [];
  }
  return [stream?.[0], stream?.[1], stream?.[2]];
}

export default useChatStreamListener;
